export default "__VITE_ASSET__CIbodqid__"